import { useEffect } from "react";

type PageMeta = {
  title: string;
  description: string;
  keywords: string;
};

const setMetaTag = (name: string, content: string, attr: "name" | "property" = "name") => {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    setMetaTag("description", description);
    setMetaTag("keywords", keywords);
    setMetaTag("og:title", title, "property");
    setMetaTag("og:description", description, "property");
  }, [title, description, keywords]);
}

export default usePageMeta;